<template>
    <v-main>
        <v-container fluid>
            <v-row cols="12">
                <v-col cols="12">
                    <runOpenai ref="runOpenai" :conversation_id="conversation_id"/>
                </v-col>
            </v-row>
        </v-container>
        <navbar title="ARES - OpenAI" type="openai" :home="true" @actionClick="actionClick" />
    </v-main>
</template>

<script>
    import navbar from '@/components/ui/navbars/navbar.vue';

    import runOpenai from '@/components/syst/openai/runOpenai.vue';

    export default {        
        components: {
            navbar,
            runOpenai,
        },
        props: {
            conversation_id: {
                type: String,
                required: false,
                default: "",
            },
        },
        data() {
            return {
                title: "",
                loading: true,
            }
        },
        methods: {
            // Dummy callback for navBar
            actionClick() {
            },           
        },
    }
</script>

<style scoped>
</style>
